import ImprovementClarificationTable from './ImprovementClarificationTable';

const HydrocarbonCondensat = ({ refreshTrigger }) => (
  <ImprovementClarificationTable
    procurementTypeHeader='2'
    refreshTrigger={refreshTrigger}
  />
);

export default HydrocarbonCondensat;
